export default "__VITE_ASSET__ryWBaPAa__"